import { Accordion } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { container } from 'tsyringe';
import { SummaryService } from '@iq-solutions/nida-shared';
import { SummaryResults } from '@iq-solutions/nida-shared/src/services/summary';

interface DrugData {
  drug: [string, string];
}

const drugRiskComponent = (props: DrugData): JSX.Element => {
  const [summary, setSummary] = useState<Array<SummaryResults>>();
  const [riskData, setRiskData] = useState<SummaryResults>();
  const drug = props.drug[0];
  const risk = props.drug[1];

  useEffect(() => {
    const getQuestionsData = container.resolve(SummaryService);
    getQuestionsData
      .fetchQuestions(`${process.env.REACT_APP_HOST_API}/taps-summary`)
      .then((res: Array<SummaryResults>) => {
        setSummary(res);
      })
      .catch(() => {
        console.log('Failed to find date from https://nida.nih.gov/api/taps-summary');
      });
  }, []);

  useEffect(() => {
    if (summary) {
      let res: SummaryResults = summary.find((e) => {
        return e.drug.toLowerCase() === drug && e.riskLevel.toLowerCase() === risk;
      })!;
      setRiskData(res);
    }
  }, [summary]);

  return (
    <div className="card">
      <h2 className={'title ' + risk}>{riskData?.displayTitle}</h2>
      <div className="description">
        <h3>Implications</h3>
        <p dangerouslySetInnerHTML={{ __html: riskData?.description! }}></p>
      </div>
      <Accordion title="Suggested Action">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <h5>Suggested Action</h5>
          </Accordion.Header>
          <Accordion.Body
            dangerouslySetInnerHTML={{ __html: riskData?.suggestedAction! }}
          ></Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {riskData?.additionalResources! !== '' ? (
        <Accordion title="Additional Resources">
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h5>Additional Resources</h5>
            </Accordion.Header>
            <Accordion.Body
              dangerouslySetInnerHTML={{ __html: riskData?.additionalResources! }}
            ></Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : null}
    </div>
  );
};
export default drugRiskComponent;
